import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-staging-banner',
  templateUrl: './staging-banner.component.html',
  styleUrls: ['./staging-banner.component.scss']
})
export class StagingBannerComponent implements OnInit {

  show$: Observable<boolean> = of(false);

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.show$ = this.http.get<any>(environment.apiUrl + 'api/v1/public/system-status').pipe(
      map((res) => res?.details?.stagingBanner === true),
      catchError(() => of(false)),
    );
  }

}
